export * from './adapters';
export * from './utils';
export * from '@omegagrid/tree';
export * from '@omegagrid/toolbar';
export * from '@reporting/rp-app-host';

import { ComponentId } from "@omegagrid/core";
import rp, { AppComponent, Application, Container, parseComponentId } from '@reporting/rp-app-host';
import { componentFactories } from './factories';
import { AccountingSearchProvider } from './searchProvider';

export class AccountingApplication extends Application {

	async register(container: Container) {
		super.register(container);
		container.services.register('accounting');

		if (!rp.userProvider.isGuest()) {
			container.commands.registerProvider(new AccountingSearchProvider());
		}
	}

	async init(container: Container) {
		super.init(container);
		container.services.register('definition');
		container.services.register('server');
		container.services.register('domain');
	}

	createComponent(id: ComponentId): AppComponent|Promise<AppComponent> {
		const parsedId = parseComponentId(id);
		const factory = componentFactories.get(parsedId.id as string || parsedId.type);
		if (!factory) return null;
		return factory(this, parsedId);
	}
}
